import { imageAccept } from "../../../utils/validateImage";
import { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { MdUpload } from "react-icons/md";
import { toast } from "react-toastify";
import validateImage from "../../../utils/validateImage";

const BlogCategoryDialog = ({
  show,
  handleClose,
  selectedCategory,
  onCancel,
  onSubmit,
}) => {
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [oldImage, setOldImage] = useState(null);
  const fileInputRef = useRef();

  useEffect(() => {
    if (selectedCategory) {
      setName(selectedCategory.name || "");
      setImage(selectedCategory.image || null);
      setOldImage(null);
    } else {
      setName("");
      setImage(null);
      setOldImage(null);
    }
  }, [show, selectedCategory]);

  const handleFileUpload = async (file) => {
    const validation = await validateImage(file);
    if (!validation.isValid) {
      toast.error(validation.error);
      return;
    }
    if (image && typeof image === "string") setOldImage(image);
    setImage(file);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) handleFileUpload(file);
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleRemoveImage = () => {
    if (image && typeof image === "string") setOldImage(image);
    setImage(null);
  };

  const handleSubmit = () => {
    if (!name.trim()) {
      toast.error("Name is required");
      return;
    }
    const data = { name, image, oldImage };
    if (selectedCategory) {
      onSubmit(selectedCategory._id, data);
    } else {
      onSubmit(data);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {selectedCategory ? "Update Blog Category" : "Add Blog Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group style={{ marginBottom: "1rem" }}>
            <Form.Label style={{ fontWeight: 600 }}>Name</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter category name"
              required
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: "1rem" }}>
            <Form.Label style={{ fontWeight: 600 }}>
              Image (optional)
            </Form.Label>
            <div
              onClick={handleBrowseClick}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "10px",
                cursor: "pointer",
              }}
            >
              <MdUpload size={24} />
              <span>
                <span
                  style={{
                    fontWeight: 600,
                    color: "blue",
                    textDecoration: "underline",
                  }}
                >
                  Browse
                </span>{" "}
                or drag and drop the image
              </span>
              <span>Up to 20 MB · JPG, PNG, WebP and AVIF</span>
              <Form.Control
                ref={fileInputRef}
                type="file" accept={imageAccept}
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
              {image && (
                <div style={{ marginTop: 10, textAlign: "center" }}>
                  <img
                    src={
                      image instanceof Blob ? URL.createObjectURL(image) : image
                    }
                    alt="Selected"
                    style={{ width: 100, height: "auto" }}
                  />
                  <div>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={handleRemoveImage}
                      style={{ marginTop: 5 }}
                    >
                      Remove
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <span
          style={{
            fontWeight: "bold",
            cursor: "pointer",
            color: "#9095A0",
            marginRight: "1.2rem",
          }}
          onClick={onCancel}
        >
          Cancel
        </span>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!name.trim()}
        >
          {selectedCategory ? "Update" : "Add"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BlogCategoryDialog;
